import type { IconProps } from "@mdi/react/dist/IconProps";
import { Toggle } from "@acdc2/ui/components/toggle";
import { Icon } from "@mdi/react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@acdc2/ui/components/tooltip";

type Props = {
  icon: IconProps["path"];
  tooltip: string;
  pressed: boolean;
  onPressedChange: () => void;
};

export function FormattingToggle({
  icon,
  tooltip,
  pressed,
  onPressedChange,
}: Props) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Toggle
            size="sm"
            pressed={pressed}
            onPressedChange={onPressedChange}
            className="cursor-pointer"
          >
            <Icon path={icon} size="1.25rem" />
          </Toggle>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
